.footer {
  margin-top: auto;
}
